import * as _ from 'underscore';

import { IWidgetLayoutElement, ISizeObj } from './Interfaces';

export function render(pos: number[], size: number[], colsArr: ISizeObj[], rowsArr: ISizeObj[]) {
    if (pos == null || size == null) {
        return;
    }

    const left = _.reduce<ISizeObj[], number>(
        colsArr.slice(0, pos[1]),
        function (memo, obj) {
            return memo + obj.size;
        },
        0
    );

    const top = _.reduce<ISizeObj[], number>(
        rowsArr.slice(0, pos[0]),
        function (memo, obj) {
            return memo + obj.size;
        },
        0
    );

    const width = _.reduce<ISizeObj[], number>(
        colsArr.slice(pos[1], pos[1] + size[1]),
        function (memo, obj) {
            return memo + obj.size;
        },
        0
    );

    const height = _.reduce<ISizeObj[], number>(
        rowsArr.slice(pos[0], pos[0] + size[0]),
        function (memo, obj) {
            return memo + obj.size;
        },
        0
    );

    return {
        left: left,
        top: top,
        right: left + width,
        bottom: top + height,
        width: width,
        height: height
    };
}

export function calculate(elements: IWidgetLayoutElement[], containerSize: number) {
    const result: ISizeObj[] = [];
    const ratio: ISizeObj[] = [];

    let totalFixedSize = 0;
    let min: ISizeObj[] = [];

    _.each(elements, (element) => {
        const obj: ISizeObj = {
            origin: element,
            size: 0
        };

        if (element.size != null) {
            totalFixedSize += element.size;

            obj.size = element.size;
        } else if (element.min != null) {
            obj.size = element.min;

            min.push(obj);
        } else {
            ratio.push(obj);
        }

        result.push(obj);
    });

    let freeSpace = containerSize - totalFixedSize;
    let sumRatio = 0;

    _.each(min.concat(ratio), (obj) => {
        sumRatio += obj.origin.ratio;
    });

    let flag = freeSpace > 0;
    let fraction = freeSpace / sumRatio;
    let ratioSize = 0;

    while (flag) {
        const _find = _.find(min, (obj) => {
            ratioSize = obj.origin.ratio * fraction;

            return obj.size > ratioSize;
        });

        if (_find == null) {
            flag = false;

            continue;
        }

        min = _.without(min, _find);
        freeSpace -= _find.size;
        sumRatio -= _find.origin.ratio;
        totalFixedSize += _find.size;

        if (freeSpace <= 0) {
            flag = false;

            continue;
        } else {
            fraction = freeSpace / sumRatio;
        }
    }

    if (freeSpace <= 0) {
        _.each(min, (obj) => {
            totalFixedSize += obj.size;
        });
    } else {
        _.each(min.concat(ratio), (obj) => {
            obj.size = obj.origin.ratio * fraction;
        });
    }

    if (totalFixedSize > containerSize) {
        containerSize = totalFixedSize;
    }

    return {
        containerSize: !Number.isNaN(containerSize) ? containerSize : undefined,
        arr: result
    };
}
